function RequestLocation(geofenceAreaSelection, multipleJurisdictionSale = false, additionalJurisdictionLists = "") {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      handlePrimaryLookupSuccess.bind(this),
      doSecondaryGeoLookup.bind(this, geofenceAreaSelection, multipleJurisdictionSale, additionalJurisdictionLists)
    );
  } else if (geoip2) {
    doSecondaryGeoLookup(geofenceAreaSelection, multipleJurisdictionSale, additionalJurisdictionLists);
  } else {
    LocationError("servicesError");
  }
}

function handlePrimaryLookupSuccess(position) {
  this.browserLocation = position;
  // Pass info onto validation
  let isSecondaryLookup = false;
  validateLocation(position, isSecondaryLookup);
}

function doSecondaryGeoLookup(geofenceAreaSelection = window.geofenceConfig.areaSelection, multipleJurisdictionSale = window.geofenceConfig.multipleJurisdictionSale, additionalJurisdictionLists = window.geofenceConfig.additionalJurisdictionLists) {
  if (!geoip2) {
    LocationError("servicesError");
    return;
  }

  // Request secondary geodata from MaxMind IP lookup
  let options = {};
  geoip2.city(
    (position) => handleSecondaryLookupSuccess(position, geofenceAreaSelection, multipleJurisdictionSale, additionalJurisdictionLists),
    handleSecondaryLookupError.bind(this),
    options
  );
}

function handleSecondaryLookupError(error) {
  if (this.browserLocation !== null) {
    // maxmind lookup failed but browser location look up success
      LocationError("outsideBounds", this.browserLocation.coords);
  } else {
      // both lookups failed, show service error
      LocationError("servicesError");
  }
}

function LocationError(errorType, coordsData) {
  let servDisplay = "block";
  let invalidDisplay = "block";
  let fbServDisplay = "block";
  // Show proper message
  switch(errorType) {
      case "outsideBounds":
          // Show location data if there is any
          if (coordsData){
              document.getElementById("location-data").innerText = "Lat " + this.NumberTrunc(coordsData.latitude, 4) +
                ", Lon " + this.NumberTrunc(coordsData.longitude, 4);
              document.getElementById("location-label").style.display = "block";
          } else{ // no data to show
              document.getElementById("location-label").style.display = "none";
          }

          invalidDisplay = "block";
          servDisplay = "none";
          fbServDisplay= "none";
          break;

      case "servicesError":
          if(this.IsFacebookApp()){
              fbServDisplay= "block";
              servDisplay = "none";
              invalidDisplay = "none";
          }
          else {
              servDisplay = "block";
              invalidDisplay = "none";
              fbServDisplay= "none";
          }
          break;
  }
  document.getElementById("location-service-error").style.display = servDisplay
  document.getElementById("grid-location-service-error").style.display = fbServDisplay == "none" ? servDisplay : fbServDisplay;
  document.getElementById("invalid-location-error").style.display = invalidDisplay;
  document.getElementById("grid-invalid-location-error").style.display = invalidDisplay;
  document.getElementById("fb-location-service-error").style.display = fbServDisplay;

  // Show error messages (i.e. popup, grid message)
  document.getElementById("top-grid-error-msg").style.display = "block";
  document.getElementById("popup-blur").style.display = "block";// popup is inside blur element
}

function validateLocation(position, isSecondaryLookup) {
  // Validate location
  let dataIsInvalid = position == null || geoData == null;
  if (dataIsInvalid && isSecondaryLookup) { // both lookups failed
    LocationError("servicesError");
  } else if (dataIsInvalid) { // primary lookup failed
    doSecondaryGeoLookup();
  }

  // Validate location
  if (geoData.constructor === Array) {
    console.log(position);
    console.log(isSecondaryLookup);
    validateLocationArray(position, isSecondaryLookup);
  } else {
    validateLocationSingle(position, isSecondaryLookup);
  }
}

function IsFacebookApp(){
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}

function HandleGeoValidationSuccess(position, passType = "primary") {
  this.browserLocation = position;
  console.log("Geo validation of location passed");

  // Update eligibility cookie
  const cookieExpiryMinutes = 60; // time until they must go through the geofence again.
  let expiry = new Date();
  expiry.setTime(expiry.getTime() + (cookieExpiryMinutes * 60 * 1000));
  const expires = "; expires=" + expiry.toGMTString();
  document.cookie = 'isEligible=true;' + expires + '; path=/';
  document.cookie = 'geoState='+position.state+';' + expires + '; path=/';
  document.cookie = 'latitude='+position.latitude+';' + expires + '; path=/';
  document.cookie = 'longitude='+position.longitude+';' + expires + '; path=/';
  document.cookie = 'passType='+passType+';' + expires + '; path=/';

  // Store lat/lon in the Order
  let locationObj = {
    "latitude": position.latitude,
    "longitude": position.longitude,
    "passType": passType,
    "state": position.state
  };
  document.getElementById("hid_latitude-longitude").value = JSON.stringify(locationObj);

  // Attempt to enable the checkout button
  updateCheckoutBtnStatus();
}

function HandleCookieLookupSuccess(position) {
  const stateFromCookies = readCookie('geoState');
  const latFromCookies = readCookie('latitude');
  const lngFromCookies = readCookie('longitude');
  const passTypeFromCookies = readCookie('passType');  position.coords.state = stateFromCookies;
  position.coords.state = stateFromCookies;
  position.coords.latitude = latFromCookies;
  position.coords.longitude = lngFromCookies;
  HandleGeoValidationSuccess(position.coords, passTypeFromCookies);
}

function HandleCookieLookupError(position) {
  const geoState = readCookie('geoState');
  const latFromCookies = readCookie('latitude');
  const lngFromCookies = readCookie('longitude');
  const passTypeFromCookies = readCookie('passType');
  if (geoState != undefined) {
    console.log("unable to get state location from cookies")
    let unknownLocation = { // refer to order that set cookie to determine location
      "latitude" : latFromCookies,
      "longitude" : lngFromCookies,
      "state" : geoState,
    }
    HandleGeoValidationSuccess(unknownLocation, passType = passTypeFromCookies); // they passed the geofence when the cookie was set
  }else {
    console.log("Unable to add geofence success info, will need to grab location from IP");
    doSecondaryGeoLookup();
  }
}

function NumberTrunc(num, decimalPlaces = 0) {
  let truncNum = num;
  let decimalModifier = 10 ** decimalPlaces;
  truncNum = num > 0 ? Math.floor(num * decimalModifier) / decimalModifier :
    Math.ceil(num * decimalModifier) / decimalModifier;
  return truncNum;
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function handleSecondaryLookupSuccess(position, geofenceAreaSelection, multipleJurisdictionSale = false, additionalJurisdictionLists = "") {
  let provState = null;
  let provCode = null;
  // Get IP's returned geo location
  if (position.subdivisions) {
    provState = position.subdivisions[0].names.en;
    provCode = position.subdivisions[0].iso_code;
  } else { // MaxMind returned empty/malformed data
    LocationError("servicesError");
  }

  // Validate it's within the geofence
  if (provState == geofenceAreaSelection) {
    const code = provCode;
    position.location.state = code;
    HandleGeoValidationSuccess(position.location, "secondary");
  } else {
    // Check for multiple jurisdiction sale and additional jurisdictions
    if (multipleJurisdictionSale == true && additionalJurisdictionLists != "") {
      // Split the additional jurisdictions into an array
      var additionalJurisdictions = additionalJurisdictionLists.split(',').map(function(item) {
        return item.trim();
      });
      // Check if the current province/state is in the additional jurisdictions list
      if (additionalJurisdictions.includes(provCode)) {
        const code = provCode;
        position.location.state = code;
        HandleGeoValidationSuccess(position.location, "secondary");
        return;
      }
    }
    console.log("Geo validation of location failed");
    LocationError("outsideBounds", position.location);
  }
  return;
}

function validateLocationArray(position, isSecondaryLookup) {
  var latTolerance = 0.01;
  var longTolerance = 0.01;
  var geoDataLocal = geoData;
  var found = 0;
  var state = "";

  for (var i = 0; i < geoDataLocal.length && found == 0; i++) {
    state = geoDataLocal[i].state;
    if (position.coords.latitude < geoDataLocal[i].border.n + latTolerance &&
      position.coords.latitude > geoDataLocal[i].border.s - latTolerance &&
      position.coords.longitude > geoDataLocal[i].border.w - longTolerance &&
      position.coords.longitude < geoDataLocal[i].border.e + longTolerance) {
      found = 1;
    }

    if (found == 1) {
      var foundBoundary = i;

      var xRes = (geoDataLocal[foundBoundary].res - 1) / (geoDataLocal[foundBoundary].border.e - geoDataLocal[foundBoundary].border.w);
      var yRes = (geoDataLocal[foundBoundary].res - 1) / (geoDataLocal[foundBoundary].border.n - geoDataLocal[foundBoundary].border.s);
      var xLookup = Math.floor((position.coords.longitude - geoDataLocal[foundBoundary].border.w) * xRes);
      var yLookup = Math.floor((geoDataLocal[foundBoundary].res - 1) - ((position.coords.latitude - geoDataLocal[foundBoundary].border.s) * yRes));

      if (xLookup < 0) {
        xLookup = 0;
      }
      if (xLookup >= geoDataLocal[foundBoundary].res) {
        xLookup = geoDataLocal[foundBoundary].res - 1;
      }
      if (yLookup < 0) {
        yLookup = 0;
      }
      if (yLookup >= geoDataLocal[foundBoundary].res) {
        yLookup = geoDataLocal[foundBoundary].res - 1;
      }

      var geoRowData = geoDataLocal[foundBoundary].data[yLookup];

      if (geoDataLocal[foundBoundary].compression == "True")
        geoRowData = DecompressRow(geoRowData);

      var geoElementIndex = Math.floor(xLookup / 4);
      var geoElementBitMask = 1 << (xLookup - (geoElementIndex * 4));
      var geoElementCharacter = geoRowData.charAt(geoElementIndex);
      var geoHex = parseInt(geoElementCharacter, 16);

      if ((geoElementBitMask & geoHex) == geoElementBitMask) {
        position.coords.state = state;
        HandleGeoValidationSuccess(position.coords);
      } else {
        found = 0;
      }
    }
  }

  if (found == 0 && isSecondaryLookup) {
    console.log("Geo validation of location failed");
    LocationError("outsideBounds", position.coords);
  } else if (found == 0) {
    console.log("Primary geo lookup shows user outside bounds, doing secondary lookup");
    doSecondaryGeoLookup();
  }
}

function DecompressRow(rowData) {
  //&16-080ff01&42-0 - form of rowData
  //alert(rowData);

  var outputRow = "";

  for (var i = 0; i < rowData.length; i++) {
    var myChar = rowData[i];

    if (myChar == "&") {
      var startPos = i + 1;
      var endPos = rowData.indexOf("-", startPos);
      i = endPos + 1;

      var numberOfRepeats = rowData.substring(startPos, endPos);
      //alert("startPos=" + startPos + ",endPos=" + endPos + ",repeats=" + numberOfRepeats);

      var repeatingChar = rowData[i];
      //alert(repeatingChar);

      //add the repeatingChar
      for (var j = 0; j < parseInt(numberOfRepeats); j++) {
        outputRow += repeatingChar;
      }
      //alert(rowData[i]);
    } else {
      outputRow += rowData[i];
    }
  }

  //alert(outputRow);
  return outputRow;
}

function validateLocationSingle(position, isSecondaryLookup) {
  var latTolerance = 0.01;
  var longTolerance = 0.01;
  var state = geoData?.state ?? null;
  // Check if within bounds and tolerance
  let isOutsideBounds = position.coords.latitude > geoData.border.n + latTolerance ||
    position.coords.latitude < geoData.border.s - latTolerance ||
    position.coords.longitude < geoData.border.w - longTolerance ||
    position.coords.longitude > geoData.border.e + longTolerance;
  if (isOutsideBounds && isSecondaryLookup) {
    LocationError("outsideBounds", position.coords);
    return;
  } else if (isOutsideBounds) {
    console.log("Primary geo lookup shows user outside bounds, doing secondary lookup");
    doSecondaryGeoLookup();
    return;
  }

  //If we reached here, they are within the bounds and within tolerance.  Align them to a resolution lookup to the geo data
  var xRes = (geoData.res - 1) / (geoData.border.e - geoData.border.w)
  var yRes = (geoData.res - 1) / (geoData.border.n - geoData.border.s)
  var xLookup = Math.floor((position.coords.longitude - geoData.border.w) * xRes)
  var yLookup = Math.floor((geoData.res - 1) - ((position.coords.latitude - geoData.border.s) * yRes)) //This one gets inverted to align with bitmap data

  //Because we allow for tolerance we need to ensure the numbers properly align to index space
  if (xLookup < 0) {
    xLookup = 0;
  }
  if (xLookup >= geoData.Res) {
    xLookup = geoData.res - 1;
  }
  if (yLookup < 0) {
    yLookup = 0;
  }
  if (yLookup >= geoData.Res) {
    yLookup = geoData.res - 1;
  }

  //Use the lookups to test the geo data if the location is within borders or not
  //The geo data is set as an array of hex data, each element in the array is a row in the map
  //Each row is a hex string representing the bits in that map

  var geoRowData = geoData.data[yLookup];

  if (geoData.compression == "True")
    geoRowData = DecompressRow(geoRowData);

  //There are 4 bits per character, find the character
  var geoElementIndex = Math.floor(xLookup / 4)
  var geoElementBitMask = 1 << (xLookup - (geoElementIndex * 4))
  var geoElementCharacter = geoRowData.charAt(geoElementIndex)
  var geoHex = parseInt(geoElementCharacter, 16);

  //Test if the bit mask is within the hex data, if so this location is on the map
  if ((geoElementBitMask & geoHex) == geoElementBitMask) {
    position.coords.state = state;
    HandleGeoValidationSuccess(position.coords);
  } else if (!isSecondaryLookup) { // Primary geofence lookup says user outside bounds, do secondary lookup
    console.log("Primary geo lookup shows user outside bounds, doing secondary lookup");
    doSecondaryGeoLookup();
  } else {
    console.log("Geo validation of location failed");
    LocationError("outsideBounds", position.coords);
  }
}

function updateCheckoutBtnStatus() {
  const isCheckbox1Valid = !document.getElementById('eligible-cbx') || document.getElementById('eligible-cbx').checked;
  const isCheckbox2Valid = !document.getElementById('eligible-cbx2') || document.getElementById('eligible-cbx2').checked;
  const isCheckbox3Valid = !document.getElementById('eligible-cbx3') || document.getElementById('eligible-cbx3').checked;
  const isCheckbox4Valid = !document.getElementById('eligible-cbx4') || document.getElementById('eligible-cbx4').checked;
  const isCheckbox5Valid = !document.getElementById('eligible-cbx5') || document.getElementById('eligible-cbx5').checked;
  const isAllCheckboxesValid = isCheckbox1Valid && isCheckbox2Valid && isCheckbox3Valid && isCheckbox4Valid && isCheckbox5Valid;

  // Update checkout button clickability
  const freeTicketButton = document.getElementById('free-ticket-button');
  if (freeTicketButton) {
      freeTicketButton.disabled = !isAllCheckboxesValid;
  }
}

function handleEnvelopeClick(e) {
  let envelopeClicked = Number($('#' + e.currentTarget.parentElement.id).attr( "data-value" ));
  let hasRevealedCard = $('#' + "suit-" + envelopeClicked).length;

  // ensure valid selection
  if (!hasRevealedCard && envelopeClicked){
      // update current pick
      $('.currentPick').removeClass('currentPick');
      $('#'+e.currentTarget.parentElement.id).addClass('currentPick');

      // Note: this element's naming convention causes cart update when
      //		"Update" or "Proceed to checkout" button's clicked(i.e. form submit)
      $("#hid_envelope-selection").val(envelopeClicked);

      // prepare for checkout
      document.getElementById("selection-validation-error").style.visibility = "hidden";
      updateCheckoutBtnStatus();
  }
}

// Event listener for DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  const isFullyEligible = readCookie('isEligible');

  const geofenceAreaSelection = window.geofenceConfig.areaSelection;
  const multipleJurisdictionSale = window.geofenceConfig.multipleJurisdictionSale;
  const additionalJurisdictionLists = window.geofenceConfig.additionalJurisdictionLists;
  const eligibleCheckboxes = Array.from(document.getElementsByClassName("eligible-checkbox"));
  const envelopes = Array.from(document.getElementsByClassName("envelope-grid-item"));
  if (!isFullyEligible) {
    RequestLocation(geofenceAreaSelection, multipleJurisdictionSale, additionalJurisdictionLists);
  } else if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(HandleCookieLookupSuccess.bind(this), HandleCookieLookupError.bind(this));
  } else {
    HandleCookieLookupError();
  }

  const ageRangeFromCookies = readCookie('ageRange');
  if (ageRangeFromCookies !== null && document.getElementById('age-range-selector') !== null) {
    document.getElementById('age-range-selector').value = ageRangeFromCookies;
    document.getElementById('hid_age_range').value = ageRangeFromCookies;
  }

  document.querySelector('.close-popup-button').addEventListener('click', function(e) {
    let parentId = e.currentTarget.parentElement.id;
    let $popupClicked = $('#' + parentId); //$popupBoxes error-popup
    let $popupBlur = $('#popup-blur');
    // hide popup elements
    $popupBlur.hide();
  });
  document.querySelector('.reopen-popup-button').addEventListener('click', function(e) {
    let $popupBlur = $('#popup-blur');
    // hide popup elements
    $popupBlur.show();
  });

  // Add event listener to all eligible-checkbox elements
  eligibleCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener('click', updateCheckoutBtnStatus);
  });
  envelopes.forEach(function(envelope) {
    envelope.addEventListener('click', handleEnvelopeClick) 
  });
});
